import { Location } from './location';
import { Reward } from './reward';
import { Dungeons } from './dungeon.repository';
var DungeonService = /** @class */ (function () {
    function DungeonService() {
        this._dungeons = Dungeons;
    }
    Object.defineProperty(DungeonService.prototype, "dungeons", {
        get: function () {
            return this._dungeons;
        },
        enumerable: true,
        configurable: true
    });
    DungeonService.prototype.hasGreenPendant = function () {
        var dungeons = Array.from(this.dungeons.values());
        if (dungeons.some(function (d) { return d.reward === Reward.GreenPendant && d.isBossDefeated; })) {
            return true;
        }
        return this.areAllRewardDungeonsBeaten();
    };
    DungeonService.prototype.hasAllPendants = function () {
        var dungeons = Array.from(this.dungeons.values());
        var pendantDungeons = dungeons
            .filter(function (d) { return d.reward === Reward.GreenPendant || d.reward === Reward.StandardPendant; });
        if (pendantDungeons.length === 3 && pendantDungeons.every(function (d) { return d.isBossDefeated; })) {
            return true;
        }
        return this.areAllRewardDungeonsBeaten();
    };
    DungeonService.prototype.hasFatFairyCrystals = function () {
        var dungeons = Array.from(this.dungeons.values());
        var fairyCrystals = dungeons
            .filter(function (d) { return d.reward === Reward.FairyCrystal; });
        if (fairyCrystals.length === 2 && fairyCrystals.every(function (d) { return d.isBossDefeated; })) {
            return true;
        }
        return this.areAllRewardDungeonsBeaten();
    };
    DungeonService.prototype.getDungeon = function (id) {
        return this.dungeons.get(id);
    };
    DungeonService.prototype.reset = function () {
        this.dungeons.forEach(function (d) { return d.reset(); });
    };
    DungeonService.prototype.allDungeons = function () {
        return Array.from(this.dungeons.values());
    };
    DungeonService.prototype.crystalDungeons = function () {
        return Array.from(this.dungeons.values())
            .filter(function (d) { return d.reward === Reward.StandardCrystal || d.reward === Reward.FairyCrystal; });
    };
    DungeonService.prototype.pendantDungeons = function () {
        return Array.from(this.dungeons.values())
            .filter(function (d) { return d.reward === Reward.StandardPendant || d.reward === Reward.GreenPendant; });
    };
    DungeonService.prototype.hasBigKey = function (id) {
        return id !== Location.CastleTower;
    };
    DungeonService.prototype.areAllRewardDungeonsBeaten = function () {
        return Array.from(this.dungeons.values())
            .filter(function (d) { return d.reward !== Reward.None; }).every(function (d) { return d.isBossDefeated; });
    };
    return DungeonService;
}());
export { DungeonService };
